const PlusSvg = (props: any) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3545 11.5H11.3545V13.5C11.3545 14.05 10.9045 14.5 10.3545 14.5C9.80449 14.5 9.35449 14.05 9.35449 13.5V11.5H7.35449C6.80449 11.5 6.35449 11.05 6.35449 10.5C6.35449 9.95 6.80449 9.5 7.35449 9.5H9.35449V7.5C9.35449 6.95 9.80449 6.5 10.3545 6.5C10.9045 6.5 11.3545 6.95 11.3545 7.5V9.5H13.3545C13.9045 9.5 14.3545 9.95 14.3545 10.5C14.3545 11.05 13.9045 11.5 13.3545 11.5ZM10.3545 0.5C4.84049 0.5 0.354492 4.986 0.354492 10.5C0.354492 16.014 4.84049 20.5 10.3545 20.5C15.8685 20.5 20.3545 16.014 20.3545 10.5C20.3545 4.986 15.8685 0.5 10.3545 0.5Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default PlusSvg
